import React from 'react';
import { Product } from '@interfaces/models/product';
import clsx from 'clsx';
import styles from './hero-pdp-header.module.scss';

export interface HeroPDPHeaderProps {
  productDetails: Product;
}

const HeroPDPHeader: React.FC<HeroPDPHeaderProps> = ({ productDetails }): React.JSX.Element => {
  return (
    <div className={styles.heroPDPHeader}>
      <h1
        className={clsx(styles.heroPDPHeader__brand, 'vc-title-s')}
        data-cy="productTitle_brand"
      >
        {productDetails.brand?.name}
        <p
          className={styles.heroPDPHeader__productName}
          data-cy="productTitle_name"
        >
          {productDetails.name}
        </p>
      </h1>
    </div>
  );
};

export default HeroPDPHeader;
